import React, { useEffect, useState } from "react";
import axios from "axios";
import { useParams } from "react-router-dom";
import Loader2 from "../../assets/loader2.gif";

//Brands
import { Brand0 } from "./Brand/Brand0";
import Brand1 from "./Brand/Brand1";
import Brand2 from "./Brand/Brand2";
import Brand3 from "./Brand/Brand3";

//Slider
import { Slider0 } from "./Slider/Slider0";
import { Slider1 } from "./Slider/Slider1";
import { Slider2 } from "./Slider/Slider2";
import { Slider3 } from "./Slider/Slider3";

//Sub-Category
import SubCategory0 from "./SubCategory/SubCategory0";
import SubCategory1 from "./SubCategory/SubCategory1";
import SubCategory2 from "./SubCategory/SubCategory2";
import SubCategory3 from "./SubCategory/SubCategory3";
import SubCategory4 from "./SubCategory/SubCategory4";
import SubCategory5 from "./SubCategory/SubCategory5";
import SubCategory6 from "./SubCategory/SubCategory6";

//Sub-Sub-Category
import SubSubCategory0 from "./SubSubCategory/SubSubCategory0";
import SubSubCategory1 from "./SubSubCategory/SubSubCategory1";
import SubSubCategory2 from "./SubSubCategory/SubSubCategory2";
import SubSubCategory3 from "./SubSubCategory/SubSubCategory3";
import SubSubCategory4 from "./SubSubCategory/SubSubCategory4";
import SubSubCategory5 from "./SubSubCategory/SubSubCategory5";
import SubSubCategory6 from "./SubSubCategory/SubSubCategory6";

//Product
import Product0 from "./Product/Product0";
import Product1 from "./Product/Product1";
import Product2 from "./Product/Product2";
import Product3 from "./Product/Product3";
import Product4 from "./Product/Product4";
import Product6 from "./Product/Product6";

//Recommended
import Recommend0 from "./Recommended/Recommended0";
import Recommend1 from "./Recommended/Recommended1";
import Recommend2 from "./Recommended/Recommended2";
import Recommend3 from "./Recommended/Recommended3";
import Recommend4 from "./Recommended/Recommended4";

//Banner
import { Banner0 } from "./Banner/Banner0";

//ProductList(subcategory )
import ProductList1 from "../ProductList/ProductList1";

//Offer
import Offer0 from "./Offer/Offer0";
import Offer1 from "./Offer/Offer1";

const Loader = () => (
  <div className="flex items-center justify-center min-h-screen">
    <img src="/Loader2.gif" alt="Loading..." className="w-30 h-30" />
  </div>
);

const MainCategory = () => {
  const API_BASE_URL = process.env.REACT_APP_API_BASE_URL;
  const [components, setComponents] = useState([]);
  const [loading, setLoading] = useState(false);
  const [currentPage, setCurrentPage] = useState(1);
  const [totalPages, setTotalPages] = useState(1);
  const limit = 10;
  const { maincategory_auto_id } = useParams();

  const fetchAppUIStyle = async (page) => {
    setLoading(true);
    try {
      const response = await axios.post(
        `${API_BASE_URL}/get_main_category_components`,
        {
          main_category_auto_id: maincategory_auto_id,
          admin_auto_id: sessionStorage.getItem("admin_auto_id"),
          app_type_id: sessionStorage.getItem("app_type_id"),
          limit: limit,
          page_number: page,
        }
      );

      const data = response.data;
      // Append the new page data if not the first page
      if (page === 1) {
        setComponents(data.get_home_component_list || []);
      } else {
        setComponents((prev) => [
          ...prev,
          ...(data.get_home_component_list || []),
        ]);
      }
      setTotalPages(data.total_pages || 1);
    } catch (error) {
      console.error("Error fetching app UI style:", error);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    // Reset to first page when maincategory_auto_id changes
    setCurrentPage(1);
    fetchAppUIStyle(1);
  }, [maincategory_auto_id]);

  useEffect(() => {
    const bottomOffset = 100;

    const handleScroll = () => {
      const { scrollTop, scrollHeight, clientHeight } =
        document.documentElement;

      if (scrollTop + clientHeight >= scrollHeight - bottomOffset) {
        if (!loading && currentPage < totalPages) {
          setCurrentPage((prev) => prev + 1);
        }
      }
    };

    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, [loading, currentPage, totalPages]);

  let subCategoryComponent = null;

  // Find the first SubCategories component with web_layout_type === 6
  for (const component of components) {
    if (
      component.component_type === "SubCategories" &&
      parseInt(component.web_layout_type, 10) === 6 &&
      currentPage === 1
    ) {
      subCategoryComponent = component;
      break; // Stop after finding the first match
    }
  }

  // If found, return ProductList1 immediately
  if (subCategoryComponent) {
    return (
      <ProductList1
        key={subCategoryComponent._id}
        data={subCategoryComponent}
      />
    );
  }

  return (
    <div>
      {components.map((component) => {
        if (
          component.component_type === "Brand" &&
          component.get_home_component_details.content.length > 0
        ) {
          const web_layout_type = parseInt(component.web_layout_type, 10);
          if (web_layout_type === 0) {
            return <Brand0 key={component._id} data={component} />;
          } else if (web_layout_type === 1) {
            return <Brand1 key={component._id} data={component} />;
          } else if (web_layout_type === 2) {
            return <Brand2 key={component._id} data={component} />;
          } else if (web_layout_type === 3) {
            return <Brand3 key={component._id} data={component} />;
          } else {
            return <Brand0 key={component._id} data={component} />;
          }
        }

        if (
          component.component_type === "Slider" &&
          component.get_home_component_details.content.length > 0
        ) {
          const web_layout_type = parseInt(component.web_layout_type, 10);

          if (web_layout_type === 0) {
            return <Slider0 key={component._id} data={component} />;
          } else if (web_layout_type === 1) {
            return <Slider1 key={component._id} data={component} />;
          } else if (web_layout_type === 2) {
            return <Slider2 key={component._id} data={component} />;
          } else if (web_layout_type === 3) {
            return <Slider3 key={component._id} data={component} />;
          } else {
            return <Slider0 key={component._id} data={component} />;
          }
        }

        if (
          component.component_type === "SubCategories" &&
          component.get_home_component_details.content.length > 0
        ) {
          const web_layout_type = parseInt(component.web_layout_type, 10);

          if (web_layout_type === 0) {
            return <SubCategory0 key={component._id} data={component} />;
          } else if (web_layout_type === 1) {
            return <SubCategory1 key={component._id} data={component} />;
          } else if (web_layout_type === 2) {
            return <SubCategory2 key={component._id} data={component} />;
          } else if (web_layout_type === 3) {
            return <SubCategory3 key={component._id} data={component} />;
          } else if (web_layout_type === 4) {
            return <SubCategory4 key={component._id} data={component} />;
          } else if (web_layout_type === 5) {
            return <SubCategory5 key={component._id} data={component} />;
          } else if (web_layout_type === 7) {
            return <SubCategory6 key={component._id} data={component} />;
          }else {
            return <SubCategory0 key={component._id} data={component} />;
          }
        }

        if (
          component.component_type === "SubSubCategories" &&
          component.get_home_component_details.content.length > 0
        ) {
          const web_layout_type = parseInt(component.web_layout_type, 10);

          if (web_layout_type === 0) {
            return <SubSubCategory0 key={component._id} data={component} />;
          } else if (web_layout_type === 1) {
            return <SubSubCategory1 key={component._id} data={component} />;
          } else if (web_layout_type === 2) {
            return <SubSubCategory2 key={component._id} data={component} />;
          } else if (web_layout_type === 3) {
            return <SubSubCategory3 key={component._id} data={component} />;
          } else if (web_layout_type === 4) {
            return <SubSubCategory4 key={component._id} data={component} />;
          } else if (web_layout_type === 5) {
            return <SubSubCategory5 key={component._id} data={component} />;
          } else if (web_layout_type === 6) {
            return <SubSubCategory6 key={component._id} data={component} />;
          } else {
            return <SubSubCategory0 key={component._id} data={component} />;
          }
        }

        if (component.component_type === "Products") {
          const web_layout_type = parseInt(component.web_layout_type, 10);

          if (web_layout_type === 0) {
            return <Product0 key={component._id} data={component} />;
          } else if (web_layout_type === 1) {
            return <Product1 key={component._id} data={component} />;
          } else if (web_layout_type === 2) {
            return <Product2 key={component._id} data={component} />;
          } else if (web_layout_type === 3) {
            return <Product3 key={component._id} data={component} />;
          } else if (web_layout_type === 4) {
            return <Product4 key={component._id} data={component} />;
            
          } else if (web_layout_type === 6) {
            return <Product6 key={component._id} data={component} />;
          }
          else {
            return <Product0 key={component._id} data={component} />;
          }
        }

        if (component.component_type === "Recommended") {
          const web_layout_type = parseInt(component.web_layout_type, 10);

          if (web_layout_type === 0) {
            return <Recommend0 key={component._id} data={component} />;
          } else if (web_layout_type === 1) {
            return <Recommend1 key={component._id} data={component} />;
          } else if (web_layout_type === 2) {
            return <Recommend2 key={component._id} data={component} />;
          } else if (web_layout_type === 3) {
            return <Recommend3 key={component._id} data={component} />;
          } else if (web_layout_type === 4) {
            return <Recommend4 key={component._id} data={component} />;
          } else {
            return <Recommend0 key={component._id} data={component} />;
          }
        }

        if (
          component.component_type === "Banner" &&
          component.get_home_component_details.content.length > 0
        ) {
          const web_layout_type = parseInt(component.web_layout_type, 10);

          if (web_layout_type === 0) {
            return <Banner0 key={component._id} data={component} />;
          } else {
            return <Banner0 key={component._id} data={component} />;
          }
        }

        if (component.component_type === "Offers" &&
          component.get_home_component_details.content.length > 0) {
          const web_layout_type = parseInt(component.web_layout_type, 10);

          if (web_layout_type === 0) {
            return <Offer0 key={component._id} data={component} />;
          } else if (web_layout_type === 1) {
            return <Offer1 key={component._id} data={component} />;
          } else {
            return <Product0 key={component._id} data={component} />;
          }
        }

        return null; // Return null for unhandled cases
      })}
      {loading && (
        <div className="flex items-center justify-center w-full py-4">
          <img src={Loader2} alt="Loading..." className="w-30 h-30" />
        </div>
      )}
    </div>
  );
};

export default MainCategory;